import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPlanTypesInputDto, PlanTypeDto } from '../../upm/zendra/cbd/controlling/dtos/plan-type/models';
import type { GetByIdsInputDto } from '../../upm/zendra/cbd/controlling/dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PlanTypePlanningOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlanTypeDto>({
      method: 'GET',
      url: `/api/orchestrator/planning/plan-types/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPlanTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PlanTypeDto>>({
      method: 'GET',
      url: '/api/orchestrator/planning/plan-types',
      params: { name: input.name, code: input.code, description: input.description, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlanTypeDto[]>({
      method: 'GET',
      url: '/api/orchestrator/planning/plan-types/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
}